var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('families-table',{staticClass:"mb-3"}),_c('v-card-actions',{staticClass:"justify-center"},[_c('family-modal',{attrs:{"newFamily":true}}),_c('clone-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }